export default __webpack_public_path__ + "static/media/sprinkler-center.91c9630c.jpg";